import React from 'react';

import { Clickable, Hoverable, HoverableLink, Link, Wrapper as ButtonWrapper, withBlockTypeConfigPropsV2 } from '../common/Button.jsx';
import { withHoverColorChange } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { FormButton, withValidation } from '../common/Form.jsx';
import { default as _Image } from '../common/Image.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import { ContentContainer } from '../common/Popup.jsx';
import Utilities from '../common/Utilities.jsx';

const Mode = {
    confirmation: 'confirmation',
    editionSelection: 'edition_selection'
}
function _Component(props) {
    const [editionGroups, setEditionGroups] = React.useState({ groups: [] });
    const [selectedMedium, setSelectedMedium] = React.useState('');
    const [selectedDimensions, setSelectedDimensions] = React.useState('');

    const distinct = (arr) => arr.filter((value, index, self) => self.indexOf(value) === index);
    const findHasMultipleEditions = (editionGroups) => editionGroups.groups.flatMap(x => x.editions).length > 1;
    const findSelectedGroup = (m, d) => editionGroups.groups.filter(x => x.medium == m && x.dimensions == d)[0] || {}

    const hasMultipleEditions = findHasMultipleEditions(editionGroups);
    const media = distinct(editionGroups.groups.map(x => x.medium));
    const dimensions = distinct(editionGroups.groups.filter(x => x.medium == selectedMedium).map(x => x.dimensions));

    const selectedGroup = findSelectedGroup(selectedMedium, selectedDimensions);

    const handleDropDownBlockProps = (d, blockProps) => {
        if (!d.config || !d.config.block) {
            return {};
        }
        switch (d.config.block.type) {
            case Name.Block.PurchasePopup.DropDown.DimensionsV1:
            case Name.Block.PurchasePopup.DropDown.DimensionsV2:
                blockProps.data = dimensions || [];
                blockProps.value = selectedDimensions;
                blockProps.onChange = updateDimensions;
                break;
            case Name.Block.PurchasePopup.DropDown.MediaV1:
            case Name.Block.PurchasePopup.DropDown.MediaV2:
                blockProps.data = media || [];
                blockProps.value = selectedMedium;
                blockProps.onChange = updateMedium;
                break;
            case Name.Block.PurchasePopup.DropDown.PriceV1:
            case Name.Block.PurchasePopup.DropDown.PriceV2:
                blockProps.data = (selectedGroup.editions || []).filter(x => x.active);
                blockProps.value = selectedEditionId;
                blockProps.onChange = handleEditionSelect;
                blockProps.onOption = (x) => (
                    <option key={x.editionId} value={x.editionId}>
                        {
                            x.editionType === 0
                                ? `Original | ${x.price}`
                                : x.editionType === 1
                                    ? `${x.number || 'Edition'} | ${x.price}`
                                    : x.number
                                        ? `${x.number} | ${x.price}`
                                        : x.price
                        }
                    </option>
                )
                break;
        }
        blockProps.visible = hasMultipleEditions;

        if (props.builder) {
            blockProps.disabled = props.mode == Mode.confirmation;
        } else {
            blockProps.disabled = props.disabled;
        }
    }
    const [selectedEditionId, setSelectedEditionId] = React.useState(undefined);
    const selectedEditionIdRef = React.useRef();
    selectedEditionIdRef.current = selectedEditionId;
    const updateMedium = e => {
        setSelectedMedium(e.target.value);

        const firstGroupWithMedium = editionGroups.groups.filter(x => x.medium == e.target.value)[0];
        setSelectedDimensions(firstGroupWithMedium.dimensions);

        const g = findSelectedGroup(e.target.value, firstGroupWithMedium.dimensions);
        setSelectedEditionId(g.editions[0].editionId);
    }
    const updateDimensions = e => {
        setSelectedDimensions(e.target.value);
        const g = findSelectedGroup(selectedMedium, e.target.value);
        setSelectedEditionId(g.editions[0].editionId);
    }

    const [loading, setLoading] = React.useState(!props.builder);
    React.useEffect(() => {
        if (props.builder) {
            return;
        }
        setLoading(true);
        $.get(
            '/api/editionSets',
            { editionSetId: props.inventory.id, sub: props.sub },
            function (responseData) {
                const hasMultipleEditions = findHasMultipleEditions(responseData);
                if (hasMultipleEditions) {
                    setEditionGroups(previousState => {
                        return responseData;
                    });
                    setSelectedMedium(responseData.groups[0].medium);
                    setSelectedDimensions(responseData.groups[0].dimensions);
                    setSelectedEditionId(responseData.groups[0].editions[0].editionId);
                }
                else {
                    handleUpdateCartLink(responseData.groups[0].editions[0].editionId);
                }
                setLoading(false);
            }).fail(function () {
                setLoading(false);
            });

        if (window && window.gtag) {
            gtag('event', 'purchase-modal', {
                'title': props.inventory.title
            });
        }
    }, [props.inventory.id]);

    const [cartLink, setCartLink] = React.useState('');
    const handleUpdateCartLink = function (editionId) {
        const localEditions = cart.getItemsFromStorage();
        if (editionId) {
            let found = false;
            for (let i = 0; i < localEditions.length; i++) {
                if (localEditions[i].EditionId != editionId) {
                    continue;
                }
                localEditions[i] = { EditionId: editionId, Quantity: 1 };
                found = true;
                break;
            }
            if (!found) {
                localEditions.push({ EditionId: editionId, Quantity: 1 })
            }
            cart.setItems(localEditions, props.querySub);
        }
        setCartLink(cart.formatUrl(localEditions, props.querySub));
    }

    const handleEditionSelect = function (event) {
        if (!event || !event.currentTarget) {
            return;
        }
        setSelectedEditionId(event.currentTarget.value);
    }
    const editionAdded = !hasMultipleEditions || props.formData.formState == 'success';
    const handleEditionSubmit = function () {
        if (!selectedEditionIdRef || !selectedEditionIdRef.current || props.formData.formState == 'success') {
            return;
        }
        handleUpdateCartLink(selectedEditionIdRef.current);
        props.onSubmit();
    };
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        contentConfig = props.config && props.config.documents && props.config.documents[PageType.Popup.Purchase];
    }
    if (!contentConfig) {
        contentConfig = Defaults.PageConfig[PageType.Popup.Purchase](props.config);
    }
    const handleFormFieldProps = React.useCallback(({ type }, formFieldProps) => {
        switch (type) {
            case Name.Block.PurchasePopup.SubmitButtonV1:
            case Name.Block.PurchasePopup.SubmitButtonV2:
                formFieldProps.editor = props.editor;
                formFieldProps.formState = props.formData.formState;
                formFieldProps.inPopup = true;
                formFieldProps.onClick = handleEditionSubmit
                break;
        }
    }, [props.formData.errorMessage, props.formData.formState]);
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        let blockProps = { editor: props.editor };
        switch (d.type.value) {
            case Name.Block.PurchasePopup.CartButtonV1:
            case Name.Block.PurchasePopup.CartButtonV2:
                blockProps.href = cartLink;
                blockProps.onClick = () => props.onClose();
                break;
            case Name.Block.PurchasePopup.ContinueButtonV1:
            case Name.Block.PurchasePopup.ContinueButtonV2:
                blockProps.onClick = props.onClose;
                break;
            case Name.Block.PurchasePopup.DropDown.DimensionsV1:
            case Name.Block.PurchasePopup.DropDown.DimensionsV2:
            case Name.Block.PurchasePopup.DropDown.MediaV1:
            case Name.Block.PurchasePopup.DropDown.MediaV2:
            case Name.Block.PurchasePopup.DropDown.PriceV1:
            case Name.Block.PurchasePopup.DropDown.PriceV2:
                handleDropDownBlockProps(d, blockProps);
                break;
            case Name.Block.PurchasePopup.SubmitButtonV1:
            case Name.Block.PurchasePopup.SubmitButtonV2:
                blockProps.visible = props.builder || hasMultipleEditions;
                blockProps.onFormFieldProps = handleFormFieldProps;
                break;
        }
        return blockProps;
    }
    let mode;
    if (props.builder) {
        mode = props.mode;
    } else if (!loading) {
        if (editionAdded) {
            mode = Mode.confirmation;
        } else {
            mode = Mode.editionSelection;
        }
    } else {
        return null;
    }
    return (
        <ContentContainer
            {...props}
            blockPropsHandler={handleBlockProps}
            className="ol--purchase"
            contentConfig={contentConfig}
            disabled={false}
            mode={mode}
            onFormFieldProps={handleFormFieldProps} />
    )
}
const Component = withValidation(_Component, []);

// #region CART BUTTON

function _CartButton(props) {
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let className = 'btn btn--whitelabel btn--cta btn--custom2 richText btn--form--popup';
    if (props.className) {
        className += ` ${props.className}`;
    }
    let ButtonComponent = Link;
    if (props.hoverProps != undefined) {
        ButtonComponent = HoverableLink;
    }
    return (
        <ButtonWrapper {...props}>
            <ButtonComponent
                className={className}
                design={props.design}
                hoverProps={props.hoverProps}
                href={props.href}
                style={style}
                onClick={props.onClick} />
        </ButtonWrapper>
    );
}
const CartButtonV1 = withBlockTypeConfigPropsV2(_CartButton);

const CartButtonV2 = withBlockTypeConfigPropsV2(_CartButton, undefined, true);

// #endregion CART BUTTON

// #region CONTINUE BUTTON

function _ContinueButton(props) {
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let className = 'btn btn--custom2 btn--whitelabel richText btn--form--popup';
    if (props.className) {
        className += ` ${props.className}`;
    }
    let ButtonComponent = Clickable;
    if (props.hoverProps != undefined) {
        ButtonComponent = Hoverable;
    }
    return (
        <ButtonWrapper {...props}>
            <ButtonComponent
                className={className}
                design={props.design}
                hoverProps={props.hoverProps}
                style={style}
                type="button"
                onClick={props.onClick} />
        </ButtonWrapper>
    );
}
const ContinueButtonV1 = withBlockTypeConfigPropsV2(_ContinueButton);

const ContinueButtonV2 = withBlockTypeConfigPropsV2(_ContinueButton, undefined, true);

// #endregion CONTINUE BUTTON

// #region DROP DOWN

function _DropDown(props) {    
    if (!props.builder && props.hoverProps && props.hoverProps.design) {
        const hoverStyleProps = Utilities.styleFromString(Utilities.extractStyle(props.hoverProps.design));
        Utilities.copyObject(hoverStyleProps, props.hoverProps);
    }
    const style = {}
    let typeStyle = 'p';
    if (props.design) {
        typeStyle = Utilities.moveTokenStyle(props.design, style);
    }
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let className = `btn btn--custom2 btn--whitelabel richText btn--form btn--select ${typeStyle}`;
    if (props.className) {
        className += ` ${props.className}`;
    }
    let builderOption;
    if (props.builder) {
        let display = 'Sample Drop Down Value';
        if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.type) {
            switch (props.blockConfig.block.type) {
                case Name.Block.PurchasePopup.DropDown.DimensionsV1:
                case Name.Block.PurchasePopup.DropDown.DimensionsV2:
                    display = 'Select Dimensions...';
                    break;
                case Name.Block.PurchasePopup.DropDown.MediaV1:
                case Name.Block.PurchasePopup.DropDown.MediaV2:
                    display = 'Select Medium...';
                    break;
                case Name.Block.PurchasePopup.DropDown.PriceV1:
                case Name.Block.PurchasePopup.DropDown.PriceV2:
                    display = 'Select Price...';
                    break;
            }
        }
        builderOption = <option value="">{display}</option>
    } else if (props.visible == false) {
        return null;
    }
    return (
        <ButtonWrapper
            containerStyle={props.containerStyle}
            disabled={!props.builder && props.disabled}
            inLayout={props.inLayout}
            stateSelectionDropDown={props.stateSelectionDropDown}
            wrapperClassName={props.wrapperClassName}>
            <select
                className={className}
                disabled={props.disabled}
                style={style}
                value={props.value || ''}
                onChange={props.onChange}
                onFocus={props.onFocus}
                onMouseOver={props.onMouseOver}>
                {builderOption}
                {props.data && props.data.map(x => props.onOption ? props.onOption(x) : <option key={x} value={x}>{x}</option>)}
            </select>
        </ButtonWrapper>
    )
}
const DropDownV1 = withBlockTypeConfigPropsV2(withHoverColorChange(_DropDown));
const DropDownV2 = withBlockTypeConfigPropsV2(withHoverColorChange(_DropDown), undefined, true);

// #endregion DROP DOWN

function SubmitButtonV1(props) {
    if (props.visible == false) {
        return null;
    }
    return <FormButton.V1 {...props} />
}

function SubmitButtonV2(props) {
    if (props.visible == false) {
        return null;
    }
    return <FormButton.V2 {...props} />
}

export {
    CartButtonV2,
    Component,
    ContinueButtonV2,
    DropDownV2,
    Mode,
    SubmitButtonV2,

    // DEPRECATED
    CartButtonV1,
    ContinueButtonV1,
    DropDownV1,
    SubmitButtonV1
};
